var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLnIconGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-linkedin-in",
    "data-name": "Icon awesome-linkedin-in",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.679,
    height: 26.678,
    viewBox: "0 0 26.679 26.678",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-in-2",
    "data-name": "Icon awesome-linkedin-in",
    d: "M5.972,26.679H.441V8.867H5.972ZM3.2,6.438A3.218,3.218,0,1,1,6.406,3.2,3.23,3.23,0,0,1,3.2,6.438Zm23.47,20.241H21.154V18.008c0-2.066-.042-4.716-2.876-4.716-2.876,0-3.316,2.245-3.316,4.568v8.819H9.436V8.867h5.3V11.3h.077a5.812,5.812,0,0,1,5.233-2.876c5.6,0,6.627,3.686,6.627,8.474v9.784Z",
    transform: "translate(0 -0.001)",
    fill: "#989898"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLnIconGray);
export default __webpack_public_path__ + "static/media/ln-icon-gray.278f6b51538f100199d727ff6e52fa40.svg";
export { ForwardRef as ReactComponent };